import { defineAction } from '~/prix'
import entrepreneurAgentCheckAction from './agentCheckStream.action.json' with { type: 'json' }
import {
  entrepreneurAgentCheckInput,
  entrepreneurAgentCheckOutput,
} from '../entrepreneurAgentCheck/entrepreneurAgentCheck.definition'

const entrepreneurAgentCheckDefinition = defineAction({
  ...entrepreneurAgentCheckAction,
  userActivityLog: true,
  operation: 'read' as const,
  input: entrepreneurAgentCheckInput,
  output: entrepreneurAgentCheckOutput,
})

export default entrepreneurAgentCheckDefinition
